import React, { useState, useEffect } from "react";
import axios from "axios";
import downloadLogo from "../Assets/Dashboard/download.png";
import uploadLogo from "../Assets/Dashboard/upload (2).png";

const BasicInformation = () => {
  const [basicInfo, setBasicInfo] = useState({
    linkedin: "",
    otherLinks: "",
    github: "",
    age: "",
    experience: "",
    phone: "",
    ctc: "",
    location: "",
    email: "",
  });

  const [isEditing, setIsEditing] = useState(false);
  const [uploadedFile, setUploadedFile] = useState(null);

  // Fetch basic information on component mount
  useEffect(() => {
    fetchBasicInformation();
  }, []);

  const fetchBasicInformation = async () => {
    try {
      const response = await axios.get("http://127.0.0.1:8000/dashboard/basic-information/");
      setBasicInfo(response.data);
    } catch (error) {
      console.error("Failed to fetch basic information:", error);
    }
  };

  const saveBasicInformation = async () => {
    try {
      const response = await axios.put("http://127.0.0.1:8000/dashboard/basic-information/save_basic_information/", basicInfo);
      setBasicInfo(response.data);
      setIsEditing(false);
      alert("Basic information updated successfully!");
    } catch (error) {
      console.error("Failed to update basic information:", error);
      alert("Failed to update basic information.");
    }
  };

  const handleFileUpload = async (event) => {
    const file = event.target.files[0];
    if (file) {
      const formData = new FormData();
      formData.append("resume_file", file);

      try {
        await axios.post("http://127.0.0.1:8000/dashboard/basic-information/upload_resume/", formData, {
          headers: { "Content-Type": "multipart/form-data" },
        });
        setUploadedFile(file);
        alert(`File "${file.name}" uploaded successfully.`);
      } catch (error) {
        console.error("Failed to upload file:", error);
        alert("Failed to upload file.");
      }
    }
  };

  const handleFileDownload = async () => {
    try {
      const response = await axios.get("http://127.0.0.1:8000/dashboard/basic-information/download_resume/");
      if (response.data.file_url) {
        const link = document.createElement("a");
        link.href = response.data.file_url;
        link.download = "Resume";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } else {
        alert("No file uploaded to download.");
      }
    } catch (error) {
      console.error("Failed to download file:", error);
      alert("Failed to download file.");
    }
  };

  const handleInputChange = (field, value) => {
    setBasicInfo({ ...basicInfo, [field]: value });
  };

  return (
    <div className="flex flex-col w-full mr-11 bg-white rounded-3xl mt-11 h-full">
      <h1 className="font-bold text-xl m-3 ml-7 mt-4">Basic Information</h1>
      <div className="grid grid-cols-3 gap-6 m-10 mt-4">
        {Object.entries(basicInfo).map(([key, value]) => (
          <legend key={key} className="text-gray-500">
            {key.toUpperCase().replace(/_/g, " ")} <br />
            {isEditing ? (
              <input
                type="text"
                value={value || ""}
                onChange={(e) => handleInputChange(key, e.target.value)}
                className="border rounded p-2 w-full"
              />
            ) : (
              <span className="text-black font-semibold">
                {value || "Not Provided"}
              </span>
            )}
          </legend>
        ))}
      </div>
      <div className="flex">
        <button
          onClick={() => setIsEditing(!isEditing)}
          className={`flex w-48 ml-10 mb-6 pt-1 pr-2 text-lg rounded text-white items-center justify-center hover:bg-white hover:text-[#0077af] hover:border-2 hover:border-[#0077af] ${
            isEditing ? "bg-gray-600" : "bg-[#0077af]"
          }`}
        >
          {isEditing ? "Cancel Edit" : "Edit"}
        </button>
        {isEditing && (
          <button
            onClick={saveBasicInformation}
            className="bg-[#0077af] text-white flex w-48 ml-10 mb-6 pt-1 pr-2 text-lg rounded hover:bg-white hover:text-[#0077af] hover:border-2 hover:border-[#0077af] items-center justify-center"
          >
            Save Changes
          </button>
        )}
        <button
          onClick={handleFileDownload}
          className="bg-[#0077af] text-white flex w-48 ml-10 mb-6 pt-1 pr-2 text-lg rounded hover:bg-white hover:text-[#0077af] hover:border-2 hover:border-[#0077af]"
        >
          <img src={downloadLogo} alt="Download" className="w-8 h-8" />
          Download Resume
        </button>
        <label className="bg-white text-[#0077af] border-2 border-[#0077af] flex w-48 ml-10 mb-6 p-1 text-lg rounded hover:bg-[#0077af] hover:text-white cursor-pointer">
          <img src={uploadLogo} alt="Upload" className="w-7 h-7 mr-2" />
          Upload Resume
          <input
            type="file"
            onChange={handleFileUpload}
            className="hidden"
          />
        </label>
      </div>
    </div>
  );
};

export default BasicInformation;
